// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nIQ_k","placeholdersHeader":"styles_placeholdersHeader__2nQex","editorStyle":"styles_editorStyle__2Zxgj","placeholdersBox":"styles_placeholdersBox__3XVgq"};